import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 20/16;
const HEIGHT = 14/16;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
        <g fill={color} fillRule="evenodd">
            <path d="M1.372 10.283v.93c.24.147 2.158 1.133 5.488 1.133 3.33 0 5.248-.985 5.488-1.131v-.932c0-1.177-2.612-2.092-2.798-2.162-.584 1.048-1.448 1.826-2.69 1.826S4.755 9.17 4.17 8.122c-.184.07-2.798.982-2.798 2.161zm1.715-6.73C3.087 1.59 4.777 0 6.86 0c2.084 0 3.773 1.59 3.773 3.553 0 .832-.145 2.11-.54 3.304 1.375.525 3.627 1.376 3.627 3.426v1.377c0 .758-2.96 2.06-6.86 2.06-3.9 0-6.86-1.304-6.86-2.06v-1.377c0-2.058 2.254-2.9 3.627-3.424a11.27 11.27 0 0 1-.54-3.306zM6.86 8.575c1.351 0 2.401-2.482 2.401-5.022 0-1.186-1.057-2.181-2.401-2.181-1.344 0-2.401.995-2.401 2.18 0 2.541 1.05 5.023 2.401 5.023zM18.563 3.086a.913.913 0 1 1 0 1.828h-1.369v1.369a.913.913 0 1 1-1.828 0V4.914h-1.369a.913.913 0 1 1 0-1.828h1.369V1.717a.913.913 0 1 1 1.828 0v1.369h1.369z"/>
        </g>
    </svg>
)

export default class IconInvite extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
